/* Perumal Namam — Y-shape matching traditional dashboard idol style
   Gold outlined, white filled arms, red srichurnam teardrop, red bindu, gold base */
export function NamamLogo({ size = 40, className = '' }) {
  return (
    <svg
      width={size}
      height={size * 1.55}
      viewBox="0 0 80 124"
      fill="none"
      className={className}
    >
      {/* === Y-shape outer gold border === */}
      <path
        d="
          M8 4 L18 8 L34 48 L34 74 L28 74 L28 78 L52 78 L52 74 L46 74 L46 48 L62 8 L72 4
          L74 6 L72 10 L64 12 L48 50 L48 74 L52 74 L52 78 L28 78 L28 74 L32 74 L32 50 L16 12 L8 10 L6 6 Z
        "
        fill="#DAA520"
      />

      {/* === White fill for the two arms + stem === */}
      {/* Left arm white */}
      <path
        d="M10 6 L17 10 L33 48 L33 50 L15 12 L9 10 L8 8 Z"
        fill="white"
      />
      {/* Right arm white */}
      <path
        d="M70 6 L63 10 L47 48 L47 50 L65 12 L71 10 L72 8 Z"
        fill="white"
      />
      {/* Center stem white */}
      <path
        d="M34 50 L34 74 L30 74 L30 76 L50 76 L50 74 L46 74 L46 50 Z"
        fill="white"
      />

      {/* === Gold inner edge lines for 3D depth === */}
      <path d="M12 7 L18 10 L34 49" stroke="#B8860B" strokeWidth="0.7" fill="none" opacity="0.6" />
      <path d="M68 7 L62 10 L46 49" stroke="#B8860B" strokeWidth="0.7" fill="none" opacity="0.6" />

      {/* === Red Srichurnam — elongated teardrop pointing up === */}
      <path
        d="M40 16 L35 52 Q35 60, 40 62 Q45 60, 45 52 Z"
        fill="#CC0000"
      />
      <path
        d="M40 19 L36.5 50 Q36.5 57, 40 59 Q43.5 57, 43.5 50 Z"
        fill="#E20000"
        opacity="0.6"
      />
      {/* Srichurnam top highlight */}
      <ellipse cx="39" cy="30" rx="1" ry="4" fill="white" opacity="0.15" />

      {/* === Red bindu circle at bottom === */}
      <circle cx="40" cy="70" r="5" fill="#CC0000" stroke="#DAA520" strokeWidth="1.5" />
      <circle cx="40" cy="70" r="3.2" fill="#E20000" />
      <circle cx="38.5" cy="68.5" r="1" fill="white" opacity="0.25" />

      {/* === Gold pedestal base === */}
      <rect x="33" y="80" width="14" height="4" rx="1" fill="#DAA520" />
      <rect x="30" y="84" width="20" height="3" rx="1" fill="#DAA520" />
      {/* Base connector */}
      <rect x="37" y="78" width="6" height="3" fill="#DAA520" />
    </svg>
  )
}

/* Sangu — Ornamental Conch Shell (Panchajanyam) matching temple style */
export function Sangu({ size = 120, className = '' }) {
  return (
    <svg
      width={size}
      height={size * 1.3}
      viewBox="0 0 120 156"
      fill="none"
      className={className}
    >
      <g stroke="#FFB74D" strokeWidth="2" fill="none">
        {/* Top finial knob */}
        <circle cx="60" cy="12" r="5" fill="#FFB74D" fillOpacity="0.2" />
        <line x1="60" y1="17" x2="60" y2="24" strokeWidth="2.5" />

        {/* Top dome / bulbous crown */}
        <path d="M38 38 C38 26, 48 20, 60 20 C72 20, 82 26, 82 38" strokeWidth="2" />
        <path d="M42 38 C42 30, 50 24, 60 24 C70 24, 78 30, 78 38" strokeWidth="1.5" opacity="0.5" />

        {/* Decorative small petals at crown top */}
        <path d="M52 22 C54 18, 56 17, 60 16 C64 17, 66 18, 68 22" strokeWidth="1.5" />
        <circle cx="60" cy="16" r="2" fill="#FFB74D" fillOpacity="0.3" />

        {/* Ornamental band / belt across middle of dome */}
        <line x1="36" y1="40" x2="84" y2="40" strokeWidth="2" />
        <line x1="37" y1="43" x2="83" y2="43" strokeWidth="1" opacity="0.5" />
        {/* Dot pattern on belt */}
        {[40, 46, 52, 58, 64, 70, 76, 80].map((x) => (
          <circle key={`belt${x}`} cx={x} cy="41.5" r="1" fill="#FFB74D" fillOpacity="0.5" />
        ))}

        {/* Main conch body */}
        <path d="M36 40 C30 48, 28 58, 32 70 C34 78, 40 88, 48 96 L60 110 L72 96 C80 88, 86 78, 88 70 C92 58, 90 48, 84 40" strokeWidth="2" />

        {/* Inner spiral — the signature conch spiral */}
        <path d="M60 36 C46 42, 38 56, 42 70 C46 82, 56 90, 64 84" strokeWidth="2" />
        <path d="M60 44 C50 48, 44 58, 47 68 C50 76, 56 80, 62 76" strokeWidth="1.5" opacity="0.6" />
        <path d="M60 52 C54 54, 50 60, 52 66 C54 70, 58 72, 60 68" strokeWidth="1" opacity="0.4" />

        {/* Spiral center eye */}
        <circle cx="56" cy="62" r="3" fill="#FFB74D" fillOpacity="0.15" strokeWidth="1" />

        {/* Bottom pointed tip */}
        <path d="M52 104 L60 118 L68 104" strokeWidth="2" strokeLinejoin="round" />
        <circle cx="60" cy="122" r="3" fill="#FFB74D" fillOpacity="0.2" />

        {/* Left hanging pendants */}
        <line x1="32" y1="40" x2="28" y2="48" strokeWidth="1.5" />
        <path d="M24 48 C24 48, 28 46, 32 48 C32 54, 28 58, 28 58" strokeWidth="1.5" />
        <ellipse cx="28" cy="60" rx="3" ry="5" strokeWidth="1.5" />
        <circle cx="28" cy="66" r="1.5" fill="#FFB74D" fillOpacity="0.4" />

        <line x1="28" y1="50" x2="20" y2="56" strokeWidth="1" opacity="0.7" />
        <ellipse cx="18" cy="60" rx="2.5" ry="4.5" strokeWidth="1.2" opacity="0.7" />
        <circle cx="18" cy="66" r="1.5" fill="#FFB74D" fillOpacity="0.3" />

        {/* Right hanging pendants */}
        <line x1="88" y1="40" x2="92" y2="48" strokeWidth="1.5" />
        <path d="M96 48 C96 48, 92 46, 88 48 C88 54, 92 58, 92 58" strokeWidth="1.5" />
        <ellipse cx="92" cy="60" rx="3" ry="5" strokeWidth="1.5" />
        <circle cx="92" cy="66" r="1.5" fill="#FFB74D" fillOpacity="0.4" />

        <line x1="92" y1="50" x2="100" y2="56" strokeWidth="1" opacity="0.7" />
        <ellipse cx="102" cy="60" rx="2.5" ry="4.5" strokeWidth="1.2" opacity="0.7" />
        <circle cx="102" cy="66" r="1.5" fill="#FFB74D" fillOpacity="0.3" />

        {/* Decorative curls at sides */}
        <path d="M34 36 C30 34, 26 36, 28 40" strokeWidth="1.5" />
        <path d="M86 36 C90 34, 94 36, 92 40" strokeWidth="1.5" />
      </g>
    </svg>
  )
}

/* Chakram — Ornamental Sudarshana Chakra (Discus) matching temple style */
export function Chakram({ size = 120, className = '' }) {
  return (
    <svg
      width={size}
      height={size * 1.3}
      viewBox="0 0 120 156"
      fill="none"
      className={className}
    >
      <g stroke="#FFB74D" strokeWidth="2" fill="none">
        {/* Top lotus crown */}
        <path d="M52 18 C54 10, 58 6, 60 4 C62 6, 66 10, 68 18" strokeWidth="1.5" />
        <path d="M48 20 C49 14, 52 10, 55 8" strokeWidth="1.2" opacity="0.6" />
        <path d="M72 20 C71 14, 68 10, 65 8" strokeWidth="1.2" opacity="0.6" />
        {/* Lotus petals */}
        <path d="M46 22 C48 16, 52 12, 56 10" strokeWidth="1" opacity="0.5" />
        <path d="M74 22 C72 16, 68 12, 64 10" strokeWidth="1" opacity="0.5" />
        <path d="M44 24 L76 24" strokeWidth="1.5" />

        {/* Top connecting stem */}
        <line x1="60" y1="24" x2="60" y2="30" strokeWidth="2.5" />

        {/* Main outer circle */}
        <circle cx="60" cy="68" r="38" strokeWidth="2.5" />

        {/* Second ring with dot pattern */}
        <circle cx="60" cy="68" r="33" strokeWidth="1.5" />
        {/* Dots between outer rings */}
        {Array.from({ length: 24 }, (_, i) => {
          const angle = (i * 15 * Math.PI) / 180
          return (
            <circle
              key={`od${i}`}
              cx={60 + 35.5 * Math.cos(angle)}
              cy={68 + 35.5 * Math.sin(angle)}
              r="1.2"
              fill="#FFB74D"
              fillOpacity="0.5"
            />
          )
        })}

        {/* Inner decorative ring */}
        <circle cx="60" cy="68" r="26" strokeWidth="1" opacity="0.5" />

        {/* Sunflower / lotus center pattern — petals radiating */}
        {Array.from({ length: 16 }, (_, i) => {
          const angle = (i * 22.5 * Math.PI) / 180
          const x1 = 60 + 10 * Math.cos(angle)
          const y1 = 68 + 10 * Math.sin(angle)
          const x2 = 60 + 24 * Math.cos(angle)
          const y2 = 68 + 24 * Math.sin(angle)
          const xm = 60 + 17 * Math.cos(angle)
          const ym = 68 + 17 * Math.sin(angle)
          // Petal shape
          const perpAngle = angle + Math.PI / 2
          const px = 3.5 * Math.cos(perpAngle)
          const py = 3.5 * Math.sin(perpAngle)
          return (
            <path
              key={`petal${i}`}
              d={`M${x1} ${y1} C${xm + px} ${ym + py}, ${xm + px} ${ym + py}, ${x2} ${y2} C${xm - px} ${ym - py}, ${xm - px} ${ym - py}, ${x1} ${y1}`}
              strokeWidth="1"
              fill="#FFB74D"
              fillOpacity="0.08"
              opacity="0.8"
            />
          )
        })}

        {/* Inner circle */}
        <circle cx="60" cy="68" r="10" strokeWidth="1.5" />
        {/* Center dot — hub */}
        <circle cx="60" cy="68" r="4" fill="#FFB74D" fillOpacity="0.25" strokeWidth="1" />
        <circle cx="60" cy="68" r="2" fill="#FFB74D" fillOpacity="0.4" />

        {/* Bottom stem / handle */}
        <line x1="60" y1="106" x2="60" y2="116" strokeWidth="2.5" />
        <circle cx="60" cy="120" r="4" fill="#FFB74D" fillOpacity="0.15" strokeWidth="1.5" />

        {/* Left hanging pendants */}
        <line x1="26" y1="56" x2="20" y2="62" strokeWidth="1.5" />
        <path d="M16 62 C16 62, 20 60, 24 62 C24 68, 20 72, 20 72" strokeWidth="1.5" />
        <ellipse cx="20" cy="74" rx="3" ry="5" strokeWidth="1.5" />
        <circle cx="20" cy="80" r="1.5" fill="#FFB74D" fillOpacity="0.4" />

        <line x1="22" y1="64" x2="14" y2="70" strokeWidth="1" opacity="0.7" />
        <ellipse cx="12" cy="74" rx="2.5" ry="4.5" strokeWidth="1.2" opacity="0.7" />
        <circle cx="12" cy="80" r="1.5" fill="#FFB74D" fillOpacity="0.3" />

        {/* Right hanging pendants */}
        <line x1="94" y1="56" x2="100" y2="62" strokeWidth="1.5" />
        <path d="M104 62 C104 62, 100 60, 96 62 C96 68, 100 72, 100 72" strokeWidth="1.5" />
        <ellipse cx="100" cy="74" rx="3" ry="5" strokeWidth="1.5" />
        <circle cx="100" cy="80" r="1.5" fill="#FFB74D" fillOpacity="0.4" />

        <line x1="98" y1="64" x2="106" y2="70" strokeWidth="1" opacity="0.7" />
        <ellipse cx="108" cy="74" rx="2.5" ry="4.5" strokeWidth="1.2" opacity="0.7" />
        <circle cx="108" cy="80" r="1.5" fill="#FFB74D" fillOpacity="0.3" />

        {/* Decorative side curls */}
        <path d="M24 60 C20 56, 16 58, 18 62" strokeWidth="1.5" />
        <path d="M96 60 C100 56, 104 58, 102 62" strokeWidth="1.5" />
      </g>
    </svg>
  )
}
